<template>
  <b-modal id="contact-modal" ref="modal" hide-footer centered>
    <template slot="modal-header">
      <div class="m-modal-header">
        <h2 class="top-title mb-0">领取</h2>
        <img
          src="@/assets/images/icon_modal_close.png"
          alt
          class="close-button"
          @click.stop="clickClose"
        />
      </div>
    </template>
    <template slot="default">
      <div class="m-modal-content">
        <p class="item">
          <span class="key">联系人：</span>
          <span class="value">{{ name }}</span>
        </p>
        <p class="item">
          <span class="key">联系电话：</span>
          <span class="value">{{ phone }}</span>
        </p>
        <p class="item">
          <span class="key">电子邮箱：</span>
          <span class="value">{{ email }}</span>
        </p>
        <p class="prompt">
          <span>提示：</span
          >请根据注册或认证时签署协议，需在沟通过程中严格遵守平台
          服务要求，如平台收到客户投诉将核对后将降低服务等级，严重投诉
          将撤销认证或注销账号。
        </p>
        <button
          class="confirm-button d-block mx-auto my-5"
          @click.stop="confirm"
        >
          确认
        </button>
      </div>
    </template>
    <template slot="modal-footer" class="w-100">
      <p class="float-left">Modal Footer Content</p>
      <b-button variant="primary" size="sm" class="float-right">Close</b-button>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
#contact-modal {
  width: 60%;
  .m-modal-header {
    width: 100%;
    display: flex;
    align-items: center;
    .top-title {
      flex: 1;
      font-size: 1.25rem;
      color: #333333;
      text-align: left;
      border-left: 0.19rem $acentColor solid;
      padding-left: 0.5rem;
    }
    .close-button {
      color: $acentColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .m-modal-content {
    .item {
      .key {
        font-size: 1.25rem;
        color: #999999;
        line-height: 2.56rem;
      }
      .value {
        font-size: 1.25rem;
        color: #333333;
      }
    }
    .prompt {
      color: #666;
      font-size: 1rem;
      span {
        color: $acentColor;
      }
    }
    .confirm-button {
      font-size: 1.25rem;
      color: white;
      width: 60%;
      height: 2.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $acentColor;
      border: none;
      outline: none;
    }
  }
}
</style>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    }
  },
  methods: {
    clickClose() {
      this.hide();
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    confirm() {
      this.hide();
      this.$emit('confirm');
    }
  }
};
</script>
